import { z } from "zod";

const brand = <B extends string>(b: B) => z.string().min(1).brand(b);

export const PlayerId = brand("PlayerId");
export type PlayerId = z.infer<typeof PlayerId>;
export const SessionId = brand("SessionId");
export type SessionId = z.infer<typeof SessionId>;
export const CheckpointId = brand("CheckpointId");
export type CheckpointId = z.infer<typeof CheckpointId>;
export const ChainOpId = brand("ChainOpId");
export type ChainOpId = z.infer<typeof ChainOpId>;
export const LinkSessionId = brand("LinkSessionId");
export type LinkSessionId = z.infer<typeof LinkSessionId>;

/** Base58 Solana address. */
export const Address = z.string().regex(/^[1-9A-HJ-NP-Za-km-z]{32,44}$/);
export const WalletAddress = Address.brand("WalletAddress");
export type WalletAddress = z.infer<typeof WalletAddress>;
export const AssetAddress = Address.brand("AssetAddress");
export type AssetAddress = z.infer<typeof AssetAddress>;

/** Lowercase hex strings. */
export const Hex = z.string().regex(/^([0-9a-f]{2})*$/);
export type Hex = z.infer<typeof Hex>;
export const Hex32 = z.string().regex(/^[0-9a-f]{64}$/);
export type Hex32 = z.infer<typeof Hex32>;
export const Fingerprint = Hex32.brand("Fingerprint");
export type Fingerprint = z.infer<typeof Fingerprint>;

/** u64 values (frames, lamports) travel as decimal strings. */
export const U64String = z.string().regex(/^\d{1,20}$/);
export type U64String = z.infer<typeof U64String>;
